// extracted by mini-css-extract-plugin
export var formContainer = "_j7-0";
export var message = "_j7-1";